import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LoadingPage from '../pages/error-pages/LoadingPage.jsx';
import { UserAuth } from '../authentication/AuthContext.jsx';
import { getGameRegistriesByOrgIdWithAccessibility } from '../services/admin-settings/GameService.jsx';
import { gameEntryPath } from './onboardingSteps.js';

// Where the user goes when the one game cannot be worked out: the games list, which loads and reports for itself.
export const LANDING_FALLBACK = '/game';
// The landing has no page of its own to report on, so it never decides for longer than this - whether the token or
// the games lookup is what has not arrived - before it sends the user to the games list.
export const LANDING_WAIT_MS = 15000;

// The one game the user can open in the current org (its Homepage, or its wizard while in setup), else the games list.
export const landingPathFor = (catalogue) => {
    const open = (Array.isArray(catalogue) ? catalogue : []).filter((g) => g?.id && g.accessible);
    return open.length === 1 ? gameEntryPath(open[0]) : LANDING_FALLBACK;
};

// LANDING_PATH: reads the current org's games after any reload, so a game granted a moment ago counts.
const LandingRedirect = () => {
    const { user } = UserAuth();
    const orgId = useSelector((state) => state.dashboardContext?.selectedOrgId);
    const [target, setTarget] = useState(null);

    useEffect(() => {
        const timer = setTimeout(() => setTarget((current) => current || LANDING_FALLBACK), LANDING_WAIT_MS);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!user?.accessToken) return undefined;
        if (!orgId) {
            setTarget(LANDING_FALLBACK);
            return undefined;
        }
        let cancelled = false;
        getGameRegistriesByOrgIdWithAccessibility({ orgId, accessToken: user.accessToken })
            .then((resp) => (resp?.games || []).map((item) => ({ ...item.game, accessible: !!item.accessible })))
            .then((games) => { if (!cancelled) setTarget((current) => current || landingPathFor(games)); })
            .catch(() => { if (!cancelled) setTarget(LANDING_FALLBACK); });
        return () => { cancelled = true; };
    }, [user?.accessToken, orgId]);

    return target ? <Navigate to={target} replace /> : <LoadingPage />;
};

export default LandingRedirect;
